"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./IconButton"));



//////////////////
// WEBPACK FOOTER
// ./src/components/IconButton/index.ts
// module id = 302
// module chunks = 0